import React from 'react';

const UserThumbnail = ({ img, withCounter, count }) => (
  <div className="right relative sm-mr1 a-user-thumbnail-box">
    <img className="right mt8 mr5 circle" src={img} alt="user-thumbnail" height="22px" />
    { withCounter &&
      <span className="white bg-red radius-1 a-font-size-4 a-header-notify-count">{count}</span>
    }
  </div>
);

UserThumbnail.defaultProps = {
  img: '/images/no-avatar.jpg',
  count: 0,
  withCounter: false
};

export default UserThumbnail;
